var app = angular.module('leonardo');

var WPProgressbar = function ($timeout) {
  return {
    restrict: 'A',
    scope: {
      options: '=*',
      value: '=',
      text: '='
    },
    link: function (scope, element, attrs) {
      var el = element[0];

      scope.$on('$destroy', function () {
        el.innerHTML = '';
        scope.progressbar = null;
      });

      scope.$watchCollection('options', function (options) {
        el.innerHTML = '';
        var type = capitalize(attrs.wpProgressbar);
        scope.progressbar = new ProgressBar[type](el, options);
      });

      scope.$watch('value', function (value) {
        if ((value === null) || (value === undefined) || (value === '') || !scope.progressbar) return;
        var options = attrs.animateOptions ? angular.fromJson(attrs.animateOptions) : {};
        scope.progressbar.animate(value, options);
      });
      scope.$watch('text', function (text) {
        if (!text || !scope.progressbar) return;
        scope.progressbar.setText(text);
      });
    }
  };
};

app.directive('wpProgressbar', ['$timeout', WPProgressbar]);
